import { observable, action, makeObservable, set } from 'mobx';

import { SerialNumberType } from '../../shared/support/modelTypes';

export interface SerialNumberFormStoreType {
	model: SerialNumberType;
	list: Array<any>;
	isLoading: boolean;
	isNew: boolean;
	isChanged: boolean;
	responseCode: number;
	responseHistoryCode: number;
	pluralName: string;
	collectedModels: Array<any>;
	filterInclude?: Array<any>;
	selectedItems: Array<any>;
	name: string;
	isFirstLoad: boolean;
	setValue(model: any, key: string, value: any): void;
}

class SerialNumberFormStore implements SerialNumberFormStoreType {
	constructor() {
		makeObservable(this, {
			model: observable,
			list: observable,
			isLoading: observable,
			isNew: observable,
			responseCode: observable,
			responseHistoryCode: observable,
			isChanged: observable,
			pluralName: observable,
			collectedModels: observable,
			selectedItems: observable,
			name: observable,
			isFirstLoad: observable,
			setValue: action
		});
	}

	model = {
		serialNumber: '',
		gtin: null,
		deleted: false,
		displayName: null,
		name: { ru: '' },
		ownerId: null,
		ownerType: null,
		priority: null
	};
	list = [];
	isLoading = false;
	isNew = false;
	responseCode = 0;
	responseHistoryCode = 0;
	isChanged = false;
	pluralName = 'serialNumbers';
	collectedModels = [] as Array<any>;
	selectedItems = [] as Array<any>;
	name = 'OrmSerialNumber';
	isFirstLoad = true;
	setValue(model: any, key: string, value: any) {
		set(model, key, value);
	}
}

export const serialNumberFormStore = new SerialNumberFormStore();

export default SerialNumberFormStore;
